"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var CredentialsSerialiser = require("./../../services/authentication/credentials-serialiser");
var writeByteViaString = function (bos, sb) { return Codec.writeByte(bos, parseInt(sb, 10)); };
/**
 * Serialiser for {@link RemoteServerDefinition}
 */
var RemoteServerDefinitionSerialiserClass = /** @class */ (function (_super) {
    __extends(RemoteServerDefinitionSerialiserClass, _super);
    function RemoteServerDefinitionSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link RemoteServerDefinition} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link RemoteServerDefinition} to be written
     */
    RemoteServerDefinitionSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.name);
        Codec.writeString(bos, value.url);
        Codec.writeString(bos, value.principal);
        Codec.writeObject(bos, value.connectionOptions, writeByteViaString, Codec.writeString);
        Codec.writeString(bos, value.missingTopicNotificationFilter !== undefined
            ? value.missingTopicNotificationFilter
            : '');
        CredentialsSerialiser.write(bos, value.credentials);
    };
    return RemoteServerDefinitionSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.RemoteServerDefinitionSerialiserClass = RemoteServerDefinitionSerialiserClass;
/**
 * The {@link RemoteServerDefinitionSerialiserClass} singleton
 */ // tslint:disable-next-line:variable-name
exports.RemoteServerDefinitionSerialiser = new RemoteServerDefinitionSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/remote-server-definition-serialiser.js
// module id = 1992
// module chunks = 1